import axios from 'axios'
import { PageResponse } from '../../../types/PageResponse'
import {
  NewsAttachment, NewsPostCreateRequest, NewsPostResponse, NewsPostUpdateRequest, NewsUnreadCountResponse,
} from '../models/types'

const baseUrl = `${process.env.REACT_APP_API_URL}/v1/news`

interface DataResponse<T> {
  data: T
}

export async function fetchNewsPostsPageV1(
  params: { page: number; size: number },
  opts?: { signal?: AbortSignal },
) {
  const { data } = await axios.get<DataResponse<PageResponse<NewsPostResponse>>>(baseUrl, {
    signal: opts?.signal,
    params: {
      page: params.page,
      size: params.size,
    },
  })

  return data.data
}

export async function fetchNewsPostByIdV1(id: number, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<DataResponse<NewsPostResponse>>(`${baseUrl}/${id}`, { signal: opts?.signal })

  return data.data
}

export async function createNewsPostV1(request: NewsPostCreateRequest) {
  const { data } = await axios.post<DataResponse<NewsPostResponse>>(baseUrl, request)

  return data.data
}

export async function updateNewsPostV1(id: number, request: NewsPostUpdateRequest) {
  const { data } = await axios.put<DataResponse<NewsPostResponse>>(`${baseUrl}/${id}`, request)

  return data.data
}

export async function uploadNewsAttachmentV1(postId: number, file: File, opts?: { signal?: AbortSignal }) {
  const formData = new FormData()
  formData.append('file', file, file.name)
  const { data } = await axios.post<DataResponse<NewsAttachment>>(`${baseUrl}/${postId}/attachments`, formData, {
    signal: opts?.signal,
  })

  return data.data
}

export async function fetchNewsAttachmentUrlV1(postId: number, attachmentId: number) {
  const { data } = await axios.get<DataResponse<{ url: string }>>(`${baseUrl}/${postId}/attachments/${attachmentId}/url`)

  return data.data.url
}

export async function setNewsPostPinnedV1(id: number, pinned: boolean) {
  await axios.patch(`${baseUrl}/${id}/pinned`, { pinned })
}

export async function deleteNewsPostV1(id: number) {
  await axios.delete(`${baseUrl}/${id}`)
}

export async function deleteNewsAttachmentV1(postId: number, attachmentId: number) {
  await axios.delete(`${baseUrl}/${postId}/attachments/${attachmentId}`)
}

export async function fetchNewsUnreadCountV1(since: string, opts?: { signal?: AbortSignal }) {
  const { data } = await axios.get<DataResponse<NewsUnreadCountResponse>>(`${baseUrl}/unread-count`, {
    signal: opts?.signal,
    params: { since },
  })

  return data.data.count
}
